import Navbar from '@/components/feature/Navbar';
import HeroSection from '@/components/feature/HeroSection';
import ForStudentsSection from '@/components/feature/ForStudentsSection';
import ForConsultanciesSection from '@/components/feature/ForConsultanciesSection';
import HowItWorksSection from '@/components/feature/HowItWorksSection';
import FeaturesSection from '@/components/feature/FeaturesSection';
import PricingSection from '@/components/feature/PricingSection';
import TestimonialsSection from '@/components/feature/TestimonialsSection';
import ContactSection from '@/components/feature/ContactSection';
import Footer from '@/components/feature/Footer';

export default function Home() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <main>
        <HeroSection />
        <ForStudentsSection />
        <ForConsultanciesSection />
        <HowItWorksSection />
        <FeaturesSection />
        <PricingSection />
        <TestimonialsSection />
        <ContactSection />
      </main>
      <Footer />
    </div>
  );
}
